module.exports = __webpack_public_path__ + "img/item-8.48de7ea1.svg";